"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuggestedPrompts = SuggestedPrompts;
exports.default = FeatureCards;
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const featureOrder = [_constants.FEATURES.EID_INSIGHTS, _constants.FEATURES.INCIDENT_ANALYSIS, _constants.FEATURES.DATA_RETRIEVAL];
const STANDALONE_SUBTITLES = {
  [_constants.FEATURES.EID_INSIGHTS]: 'Analyze identity health, detect overmerges, and review data quality across member records',
  [_constants.FEATURES.INCIDENT_ANALYSIS]: 'Get AI-powered resolution plans with human-in-the-loop approval for ServiceNow incidents',
  [_constants.FEATURES.DATA_RETRIEVAL]: 'Query Dynamo, GraphQL, CDC, and User Service records in real time'
};
function FeatureCards(_ref) {
  let {
    onSelect,
    mode = 'sidebar'
  } = _ref;
  const isStandalone = mode === 'standalone';
  if (isStandalone) {
    return (0, _jsxRuntime.jsx)("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '18px',
        maxWidth: '840px',
        width: '100%',
        margin: '0 auto'
      },
      children: featureOrder.map((fid, idx) => {
        const meta = _constants.FEATURE_META[fid];
        const delay = 0.55 + idx * 0.15;
        return (0, _jsxRuntime.jsxs)("button", {
          style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: '28px 24px',
            border: '1px solid rgba(255,255,255,0.5)',
            borderRadius: '20px',
            cursor: 'pointer',
            textAlign: 'left',
            background: 'rgba(255,255,255,0.7)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            boxShadow: '0 4px 24px rgba(0,0,0,0.04)',
            transition: 'transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease, opacity 0.3s',
            fontFamily: 'inherit',
            position: 'relative',
            overflow: 'hidden',
            animation: "sa-fadeUp 0.5s ease-out ".concat(delay, "s both")
          },
          onMouseEnter: e => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.08)';
            e.currentTarget.style.borderColor = "color-mix(in srgb, ".concat(meta.color, " 30%, rgba(255,255,255,0.5))");
            const icon = e.currentTarget.querySelector('[data-icon]');
            if (icon) icon.style.transform = 'translateY(-4px) rotate(5deg)';
            const arrow = e.currentTarget.querySelector('[data-arrow]');
            if (arrow) {
              arrow.style.opacity = '1';
              arrow.style.transform = 'translateX(4px)';
            }
          },
          onMouseLeave: e => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.04)';
            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)';
            const icon = e.currentTarget.querySelector('[data-icon]');
            if (icon) icon.style.transform = 'translateY(0) rotate(0deg)';
            const arrow = e.currentTarget.querySelector('[data-arrow]');
            if (arrow) {
              arrow.style.opacity = '0';
              arrow.style.transform = 'translateX(0)';
            }
          },
          onClick: () => onSelect(fid),
          children: [(0, _jsxRuntime.jsx)("span", {
            "data-icon": "true",
            style: {
              fontSize: '28px',
              lineHeight: 1,
              width: '56px',
              height: '56px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '16px',
              background: "color-mix(in srgb, ".concat(meta.color, " 12%, white)"),
              marginBottom: '18px',
              transition: 'transform 0.25s ease'
            },
            children: meta.icon
          }), (0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '17px',
              fontWeight: 700,
              color: '#1a1a2e',
              letterSpacing: '-0.01em',
              marginBottom: '6px'
            },
            children: meta.title
          }), (0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '13.5px',
              color: '#64748b',
              lineHeight: 1.55
            },
            children: STANDALONE_SUBTITLES[fid] || meta.subtitle
          }), (0, _jsxRuntime.jsx)("span", {
            "data-arrow": "true",
            style: {
              position: 'absolute',
              bottom: '24px',
              right: '20px',
              fontSize: '18px',
              color: meta.color,
              fontWeight: 600,
              opacity: 0,
              transition: 'opacity 0.2s, transform 0.2s'
            },
            children: "\u2192"
          })]
        }, fid);
      })
    });
  }
  return (0, _jsxRuntime.jsx)("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      maxWidth: '380px',
      margin: '0 auto'
    },
    children: featureOrder.map((fid, idx) => {
      const meta = _constants.FEATURE_META[fid];
      const delay = 0.45 + idx * 0.12;
      return (0, _jsxRuntime.jsxs)("button", {
        style: {
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '12px 14px',
          border: '1px solid rgba(0,0,0,0.05)',
          borderRadius: '14px',
          cursor: 'pointer',
          textAlign: 'left',
          background: 'rgba(255,255,255,0.75)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          boxShadow: '0 1px 4px rgba(0,0,0,0.03)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, opacity 0.3s',
          fontFamily: 'inherit',
          position: 'relative',
          animation: "sa-fadeUp 0.45s ease-out ".concat(delay, "s both")
        },
        onMouseEnter: e => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.06)';
          e.currentTarget.style.borderColor = "color-mix(in srgb, ".concat(meta.color, " 25%, rgba(0,0,0,0.05))");
          const icon = e.currentTarget.querySelector('[data-sicon]');
          if (icon) icon.style.transform = 'scale(1.1) rotate(3deg)';
          const arrow = e.currentTarget.querySelector('[data-sarrow]');
          if (arrow) {
            arrow.style.opacity = '1';
            arrow.style.transform = 'translateX(2px)';
          }
        },
        onMouseLeave: e => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.03)';
          e.currentTarget.style.borderColor = 'rgba(0,0,0,0.05)';
          const icon = e.currentTarget.querySelector('[data-sicon]');
          if (icon) icon.style.transform = 'scale(1) rotate(0deg)';
          const arrow = e.currentTarget.querySelector('[data-sarrow]');
          if (arrow) {
            arrow.style.opacity = '0.4';
            arrow.style.transform = 'translateX(0)';
          }
        },
        onClick: () => onSelect(fid),
        children: [(0, _jsxRuntime.jsx)("span", {
          "data-sicon": "true",
          style: {
            fontSize: '22px',
            lineHeight: 1,
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '12px',
            flexShrink: 0,
            background: "color-mix(in srgb, ".concat(meta.color, " 10%, white)"),
            transition: 'transform 0.2s ease'
          },
          children: meta.icon
        }), (0, _jsxRuntime.jsxs)("div", {
          style: {
            flex: 1,
            minWidth: 0
          },
          children: [(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '13px',
              fontWeight: 600,
              color: '#1a1a2e'
            },
            children: meta.title
          }), (0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '11px',
              color: '#64748b',
              marginTop: '1px',
              lineHeight: 1.4
            },
            children: meta.subtitle
          })]
        }), (0, _jsxRuntime.jsx)("span", {
          "data-sarrow": "true",
          style: {
            fontSize: '14px',
            color: meta.color,
            fontWeight: 600,
            opacity: 0.4,
            transition: 'opacity 0.2s, transform 0.2s',
            flexShrink: 0
          },
          children: "\u2192"
        })]
      }, fid);
    })
  });
}
function SuggestedPrompts(_ref2) {
  let {
    feature,
    onSelect
  } = _ref2;
  const meta = feature && _constants.FEATURE_META[feature];
  const prompts = meta ? meta.samplePrompts : ['Show EID Insights', 'Get Incident Analysis & Recommendations', 'Get Record/Aggregate Data Across Systems'];
  return (0, _jsxRuntime.jsx)("div", {
    className: "tw-flex tw-flex-wrap tw-gap-1.5 tw-mb-2",
    children: prompts.map(p => (0, _jsxRuntime.jsx)("button", {
      className: "tw-bg-sa-primary-lt tw-text-sa-primary tw-rounded-2xl tw-px-3.5 tw-py-1 tw-text-xs tw-border-none tw-cursor-pointer tw-font-sa tw-transition-colors hover:tw-bg-blue-200",
      onClick: () => onSelect(p),
      children: p
    }, p))
  });
}